import * as styles from "./SelectScrollArrow.css";

import { clsx } from "clsx";

import { Select as BaseSelect } from "@base-ui/react/select";
import { Icon } from "@frontend/components/atoms/Icon";

import type {
  SelectScrollDownArrowProps,
  SelectScrollUpArrowProps,
} from "./Select.types";

export function SelectScrollUpArrow({
  className,
  children,
  ...props
}: SelectScrollUpArrowProps) {
  return (
    <BaseSelect.ScrollUpArrow
      data-slot="select-scroll-up-arrow"
      className={clsx(styles.scrollArrow, className)}
      {...props}
    >
      {children ?? <Icon name="ChevronUp" size="sm" />}
    </BaseSelect.ScrollUpArrow>
  );
}

export function SelectScrollDownArrow({
  className,
  children,
  ...props
}: SelectScrollDownArrowProps) {
  return (
    <BaseSelect.ScrollDownArrow
      data-slot="select-scroll-down-arrow"
      className={clsx(styles.scrollArrow, className)}
      {...props}
    >
      {children ?? <Icon name="ChevronDown" size="sm" />}
    </BaseSelect.ScrollDownArrow>
  );
}
